import { useState } from 'react';
import Modal from '../shared/Modal';
import { upsertAssignment } from '../../utils/api';

export default function AddPositionModal({ open, onClose, blockId, teamId, onAdd, showToast }) {
  const [label, setLabel] = useState('');
  const [quantity, setQuantity] = useState(1);

  function reset() { setLabel(''); setQuantity(1); }

  async function handleSave() {
    if (!label.trim()) { showToast('Position name is required.'); return; }
    if (!blockId) { showToast('No block selected.'); return; }

    // Generate IDs client-side for instant UI update
    const qty = Math.max(1, quantity);
    const now = new Date().toISOString();
    // Timestamp-based order: bigger than any drag-assigned rank (0..n) and any
    // unordered legacy row (1e9), so new positions append at the end in the
    // order they were added — and stay there.
    const orderBase = Date.now();
    const newAssignments = Array.from({ length: qty }, (_, i) => ({
      id: crypto.randomUUID(),
      blockId, teamId,
      personId: '', positionLabel: label.trim(),
      status: 'unsent', notes: '', sentAt: '', respondedAt: '',
      createdAt: now,
      order: orderBase + i,
    }));

    // Update UI and close immediately
    showToast(`${qty} position${qty > 1 ? 's' : ''} added.`);
    reset();
    onClose();
    if (onAdd) onAdd(newAssignments);

    // Persist in the background
    try {
      await Promise.all(newAssignments.map(a => upsertAssignment(a)));
    } catch (err) {
      showToast('Error saving position — please refresh.');
      console.error(err);
    }
  }

  return (
    <Modal
      open={open}
      onClose={() => { reset(); onClose(); }}
      title="Add Position"
      footer={
        <>
          <button className="btn" onClick={() => { reset(); onClose(); }}>Cancel</button>
          <button className="btn btn-dark" onClick={handleSave}>Add Position</button>
        </>
      }
    >
      <div className="form-group">
        <label className="form-label">Position Name</label>
        <input
          className="form-input"
          value={label}
          onChange={e => setLabel(e.target.value)}
          placeholder="e.g. Concourse Lead, Food Lead…"
        />
      </div>
      <div className="form-group">
        <label className="form-label">Quantity</label>
        <input
          className="form-input"
          type="number"
          value={quantity}
          onChange={e => setQuantity(Math.max(1, parseInt(e.target.value) || 1))}
          min="1"
          max="20"
        />
        <div style={{ fontFamily: 'var(--font-b)', fontSize: 12, fontWeight: 300, color: 'var(--muted)', marginTop: 6 }}>
          Creates this many open slots with the same position name.
        </div>
      </div>
    </Modal>
  );
}
